import React, { lazy } from 'react';
const AddToCalendar = lazy(() => import('react-add-to-calendar'));

export default function LazyAddToCalendar({ ...props }) {
  return <AddToCalendar {...props} />;
}
